import { useEffect, useState } from "react";

const dismissedKey = "axis-install-prompt-dismissed";

function isStandaloneApp() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
}

export default function AppInstallPrompt() {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isStandaloneApp() || localStorage.getItem(dismissedKey) === "true") {
      return undefined;
    }

    function handleBeforeInstallPrompt(event) {
      event.preventDefault();
      setInstallPrompt(event);
      setVisible(true);
    }

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  async function handleInstall() {
    if (!installPrompt) {
      return;
    }

    installPrompt.prompt();
    await installPrompt.userChoice;
    setInstallPrompt(null);
    setVisible(false);
  }

  function handleDismiss() {
    localStorage.setItem(dismissedKey, "true");
    setVisible(false);
  }

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed bottom-5 left-4 right-4 z-50 mx-auto max-w-md rounded-md border border-slate-200 bg-white p-4 text-slate-950 shadow-2xl sm:left-auto sm:right-5">
      <div className="flex gap-4">
        <img src="/axis-mark-transparent.png" alt="" className="h-12 w-12 shrink-0 object-contain" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-800">Install app</p>
          <h2 className="mt-1 text-lg font-semibold">Add Axis Compliance Solutions</h2>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Install the website for quick access to services, contact details and the salary tax calculator.
          </p>
          <div className="mt-4 flex flex-col gap-2 sm:flex-row">
            <button className="btn-primary flex-1" type="button" onClick={handleInstall}>
              Install
            </button>
            <button className="btn-secondary flex-1" type="button" onClick={handleDismiss}>
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
